import httpClient from './httpClient';

export interface JobInfoSuggestResult {
  role_id: string;
  role_name: string;
  domain: string;
}

export interface JobInfoSuggestResponse {
  query: string;
  count: number;
  results: JobInfoSuggestResult[];
}

export interface JobInfoResponsibilityLevel {
  level: number;
  level_name: string;
  summary: string;
  role_specific_description: string;
}

export interface JobInfoRelatedRole {
  role_id: string;
  role_name: string;
  reference_url: string;
}

export interface JobInfoRoleDetail {
  role_id: string;
  role_name: string;
  domain: string;
  reference_url: string;
  overview: string;
  available_levels: number[];
  key_activities: string[];
  responsibility_levels: JobInfoResponsibilityLevel[];
  related_roles: JobInfoRelatedRole[];
  revision_notes: string[];
}

export const fetchJobInfoSuggest = (q: string, limit = 50) =>
  httpClient.get<JobInfoSuggestResponse>('job_info_suggest', {
    params: { q, limit: Math.min(Math.max(limit, 1), 50) },
  });

export const fetchJobInfoRole = (roleId: string) =>
  httpClient.get<JobInfoRoleDetail>(`job_info_role/${roleId}`);
